module.exports = __webpack_public_path__ + "static/media/winteryDam.4dfa725f.webp";